import React, { useEffect, useState, useRef } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from '../../../../../../_metronic/_partials/controls';
import * as actions from '../../../_redux/stocks/stocksActions';
import { initialStock } from '../StocksUIHelpers';
import StockCreateForm from './StockCreateForm';

export function StockCreateDialog({
  history,
  match: {
    params: { id },
  },
}) {
  const intl = useIntl();
  const [tab, setTab] = useState('basic');
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const titleText = intl.formatMessage({ id: 'STOCK.TITLE.DETAIL' });
  //console.log('id=', id);

  const { actionsLoading, stockForView, error, msg } = useSelector(
    (state) => ({
      actionsLoading: state.stocks.actionsLoading,
      stockForView: state.stocks.stockForView,
      error: state.stocks.error,
      msg: state.stocks.msg,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchStock(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = intl.formatMessage({ id: 'STOCK.TITLE.DETAIL' });
    if (stockForView && id) {
      _title = `${titleText} #${stockForView.id}`;
    }
    setTitle(_title);
  }, [stockForView, id]);

  const onHide = () => {
    history.push(`/stocks`);
  };

  const saveStock = (values) => {
    if (!loading) {
      setLoading(true);
      //console.log('saveStock', values);
      if (!stockForView) {
        dispatch(actions.createStock(values));
      } else {
        dispatch(actions.updateStock(values));
      }
      setLoading(false);
    }
  };

  const newClick = () => {
    dispatch(actions.clearStock());
    history.push('/stocks/new');
  };
  const btnRefNew = useRef();
  const newStockClick = () => {
    //console.log('saveStockClick');
    if (btnRefNew && btnRefNew.current) {
      btnRefNew.current.click();
    }
  };
  const btnRefSave = useRef();
  const saveStockClick = () => {
    //console.log('saveStockClick');
    if (btnRefSave && btnRefSave.current) {
      btnRefSave.current.click();
    }
  };

  const backToList = () => {
    history.push(`/stocks`);
  };
  const goToView = (stockId) => {
    history.push(`/stocks/` + stockId + '/edit');
  };

  return (
    <>
      <Modal.Body className='overlay overlay-block cursor-default'>
        {actionsLoading && <ModalProgressBar />}
        {actionsLoading && (
          <div className='overlay-layer bg-transparent'>
            <div className='spinner spinner-lg spinner-success' />
          </div>
        )}
        <Card>
          {actionsLoading && <ModalProgressBar />}
          <CardHeader title={title}>
            <CardHeaderToolbar>
              <button
                type='button'
                onClick={backToList}
                className='btn btn-light btn-elevate'
              >
                <FormattedMessage id='GENERAL.BUTTON.CANCEL' />
              </button>
              <> </>
              <button
                type='submit'
                className='btn btn-primary ml-2'
                onClick={saveStockClick}
              >
                <FormattedMessage id='GENERAL.BUTTON.SAVE' />
                {loading && (
                  <span
                    id='stockSaveLoading2'
                    className='ml-3 spinner spinner-white '
                  ></span>
                )}
              </button>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <StockCreateForm
              actionsLoading={actionsLoading}
              stockForView={stockForView || initialStock}
              initialStock={initialStock}
              btnRefSave={btnRefSave}
              btnRefNew={btnRefNew}
              goToView={goToView}
              onHide={onHide}
              error={error}
              info={msg}
            />
          </CardBody>
        </Card>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </>
  );
}
